module.exports = __webpack_public_path__ + "img/reserveren-icon-mobile-blue.0d20e2493c29b421ce7671bad4f8e571.svg";